import React from 'react';
import { Button, Tooltip } from 'antd';
import {
  StepBackwardOutlined, LeftOutlined, RightOutlined, StepForwardOutlined,
  SearchOutlined, PlusOutlined, SaveOutlined, EditOutlined, UndoOutlined,
  DeleteOutlined, PrinterOutlined, LogoutOutlined,
} from '@ant-design/icons';
import { Mode } from '../hooks/usePW9224Mode';

interface ActionBarProps {
  mode: Mode;
  isEditing: boolean;
  record: unknown;
  currentIdx: number;
  allIdsLength: number;
  onAdd: () => void;
  onModify: () => void;
  onDelete: () => void;
  onNavTo: (idx: number) => void;
  onExit: () => void;
}

const ActionBar: React.FC<ActionBarProps> = React.memo(({
  mode, isEditing, record, currentIdx, allIdsLength,
  onAdd, onModify, onDelete, onNavTo, onExit,
}) => {
  const canNav = !isEditing && allIdsLength > 0;
  const hasRecord = !!record;

  return (
    <div className="action-bar">
      <div className="action-group">
        <Tooltip title="最前"><Button icon={<StepBackwardOutlined />} disabled={!canNav || currentIdx <= 0} onClick={() => onNavTo(0)} /></Tooltip>
        <Tooltip title="上一筆"><Button icon={<LeftOutlined />} disabled={!canNav || currentIdx <= 0} onClick={() => onNavTo(currentIdx - 1)} /></Tooltip>
        <Tooltip title="下一筆"><Button icon={<RightOutlined />} disabled={!canNav || currentIdx >= allIdsLength - 1} onClick={() => onNavTo(currentIdx + 1)} /></Tooltip>
        <Tooltip title="最後"><Button icon={<StepForwardOutlined />} disabled={!canNav || currentIdx >= allIdsLength - 1} onClick={() => onNavTo(allIdsLength - 1)} /></Tooltip>
      </div>
      <div className="action-group">
        <Tooltip title="搜尋"><Button icon={<SearchOutlined />} disabled={isEditing} /></Tooltip>
      </div>
      <div className="action-group">
        {isEditing ? (
          <Tooltip title={mode === 'add' ? '存檔' : '存檔'}>
            <Button type="primary" icon={<SaveOutlined />} onClick={onAdd}>
              {mode === 'add' ? 'F存檔' : 'F存檔'}
            </Button>
          </Tooltip>
        ) : (
          <Tooltip title="新增">
            <Button icon={<PlusOutlined />} onClick={onAdd}>A新增</Button>
          </Tooltip>
        )}
        {isEditing ? (
          <Tooltip title="還原">
            <Button icon={<UndoOutlined />} onClick={onModify}>G還原</Button>
          </Tooltip>
        ) : (
          <Tooltip title="修改">
            <Button icon={<EditOutlined />} disabled={!hasRecord} onClick={onModify}>E修改</Button>
          </Tooltip>
        )}
        <Tooltip title="刪除">
          <Button icon={<DeleteOutlined />} disabled={isEditing || !hasRecord} danger onClick={onDelete}>刪除</Button>
        </Tooltip>
      </div>
      <div className="action-group">
        <Tooltip title="列印"><Button icon={<PrinterOutlined />} disabled={isEditing || !hasRecord}>列印</Button></Tooltip>
        <Tooltip title="離開"><Button icon={<LogoutOutlined />} onClick={onExit}>離開</Button></Tooltip>
      </div>
    </div>
  );
});

ActionBar.displayName = 'ActionBar';
export default ActionBar;
